module.exports = __webpack_public_path__ + "media/images/global/icons/cake-28547afaa93bb0af92f02da9aa5ccb01.svg";